module.exports = __webpack_public_path__ + "static/media/SizeGoodOptimized.53935807.webp";